import { ThirdPartyLoaderService } from '~/services/third-party-loader.service';
import { IConfigurationProvider } from '~/types/dependency.types';

// TODO: Refactor this to be hook
interface IRecaptchaServiceProps {
    configProvider: IConfigurationProvider;
}
export class RecaptchaService {
    configProvider: IConfigurationProvider;

    constructor({ configProvider }: IRecaptchaServiceProps) {
        this.configProvider = configProvider;
    }

    async load() {
        // TODO: Need to return window.grecaptcha if already init
        await ThirdPartyLoaderService.loadScript({
            isModule: false,
            src: `https://www.google.com/recaptcha/api.js?render=${this.configProvider.config.google_recaptcha_v3_site_key}`
        });
        return window.grecaptcha;
    }

    getRecaptchaToken(actionName: string) {
        return new Promise<string>((resolve, reject) => {
            this.load()
                .then(grecaptcha => {
                    grecaptcha.ready(() => {
                        grecaptcha
                            .execute(
                                this.configProvider.config
                                    .google_recaptcha_v3_site_key,
                                { action: actionName }
                            )
                            .then(resolve, reject);
                    });
                })
                .catch(reject);
        });
    }
}
